import React, { useEffect } from 'react';
import { selectBlockIppicaScommessa, selectHasColumns, selectTipoScommessaKey } from 'features/ippica/selectors';
import { useAppDispatch, useTypedSelector } from 'lib/centralStore';

import { BlockScommessa } from 'features/ippica/settings/settings-types';
import { IppicaScommesseRendererPariDispari } from './ippicaScommesseRendererPariDispari';
import { IppicaScommesseRendererTestaATesta } from './ippicaScommesseRendererTestaATesta';
import { IppicaScommesseRendererWithCavalliKey } from './ippicaScommesseRendererWithCavalliKey';
import { Wrapper } from 'components/wrapper';
import { breakpoint } from 'utility/constant';
import classNames from 'classnames';
import dynamic from 'next/dynamic';
import { getMatrix } from 'features/ippica/actions';
import { selectIsOpenCarrello } from 'features/carrello/carrelloSelectors';
import styles from './IppicaScommesseRenderer.module.scss';
import useWindowSize, { enComparer } from 'hooks/useWindowSize';

export const DynamicIppicaScommesseRenderer = dynamic(() =>
  import('features/ippica/components/ippicaScommesseRenderer').then((mod) => mod.IppicaScommesseRenderer)
);

export const IppicaScommesseRenderer = () => {
  const dispatch = useAppDispatch();

  const { doCheck } = useWindowSize();
  const [isMobile] = doCheck([{ comparer: enComparer.less, size: breakpoint.lg }]);

  const tipoScommessaKey = useTypedSelector(selectTipoScommessaKey);
  const isOpen = useTypedSelector(selectIsOpenCarrello);
  const hasColumns = useTypedSelector(selectHasColumns);
  const blockScommessa = useTypedSelector(selectBlockIppicaScommessa);
  const { tipoGara } = useTypedSelector((state) => state.ippica.ippicaDetailRace!) || {};

  let scommesseComponentToRender: React.ReactNode;

  useEffect(() => {
    if (hasColumns) {
      dispatch(getMatrix());
    }
  }, [tipoScommessaKey, dispatch, hasColumns]);

  switch (blockScommessa) {
    case BlockScommessa.TestaTesta:
      scommesseComponentToRender = (
        <IppicaScommesseRendererTestaATesta
          tipoScommessaKey={tipoGara?.toLowerCase() == 'trotto' ? 110 : 109}
          isMobile={isMobile}
        />
      );
      break;
    case BlockScommessa.PariDispari:
      scommesseComponentToRender = (
        <IppicaScommesseRendererPariDispari
          isMobile={isMobile}
          tipoScommessaKey={tipoGara?.toLowerCase() == 'trotto' ? 120 : 119}
        />
      );
      break;
    default:
      scommesseComponentToRender = (
        <IppicaScommesseRendererWithCavalliKey tipoScommessaKey={tipoScommessaKey} isMobile={isMobile} />
      );
  }

  return (
    <Wrapper
      bgColorTransparent
      noPaddingTop
      noPaddingLeft
      noPaddingRight
      classNameWrapper={`${styles.noBorderRadiusTop} ${!isOpen ? styles.hasMarginRight : ''}`}
      className={classNames('ippicaBackground')}
    >
      {scommesseComponentToRender}
    </Wrapper>
  );
};
